import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';

const ProtectedRoute = ({ children }) => {
  const { token } = useAuth();
  const { isConnected } = useSocket();

  // Si no hay token, redirigir al login
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Opcional: Mostrar indicador de estado del socket
  const socketIndicator = isConnected !== undefined && (
    <div 
      className="socket-indicator" 
      style={{ 
        position: 'fixed', 
        bottom: '10px', 
        right: '10px',
        padding: '5px 10px',
        borderRadius: '4px',
        background: isConnected ? '#28a745' : '#dc3545',
        color: 'white',
        fontSize: '12px',
        zIndex: 9999,
        opacity: 0.8
      }}
    >
      {isConnected ? '● Conectado' : '● Desconectado'}
    </div>
  );

  return (
    <>
      {children}
      {socketIndicator}
    </>
  );
};

export default ProtectedRoute;